var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"placeholder":_vm.placeholder,"tabindex":_vm.$input.tabindex,"type":_vm.type,"hint":_vm.errorMessage,"persistent-hint":_vm.hasError,"label":_vm.label,"autocomplete":!_vm.autocomplete ? 'input-' + _vm.id : undefined,"value":_vm.value},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }